import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { setCurrentBranch, getCurrentBranch } from '../../utils/jwt';
import { API_PATH } from '../../utils/apis';

const initialState = {
    isLoading: false,
    error: false,
    deleteError: false,
    search: '',
    page: 0,
    perPage: 10,
    total: 0,
    branches: [],
    sortBy: null,
    filters: {
        method: ''
    }
};

const slice = createSlice({
    name: 'branch',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        removeDeleteError(state) {
            state.deleteError = false;
        },
        hasDeleteError(state, action) {
            state.isLoading = false;
            state.deleteError = action.payload;
        },
        getSuccess(state, action) {
            state.isLoading = false;
            state.branches = action.payload.data;
            state.total = parseInt(action.payload.total, 10);
        },
        deletedSuccess(state, action) {
            const deleted = action.payload.split(",");
            state.branches = state.branches.filter((obj) => !deleted.includes(obj.bid));
            if(deleted.includes(getCurrentBranch())){
                setCurrentBranch(null);
            }
            state.isLoading = false;
        },
        //  SORT & FILTER POSTS
        sortBy(state, action) {
            state.sortBy = action.payload;
        },
        filter(state, action) {
            state.filters.method = action.payload.method;
        },
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    filter,
    sortBy
} = slice.actions;

export function getBranches(search, stat, page, perpage, order, sortBy) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(API_PATH.branches, { page, status: stat, search, perpage, order, sortBy, });
            const { status, data, total } = response.data;
            if (status === "success") {
                dispatch(slice.actions.getSuccess({ data, total }));
            } else {
                dispatch(slice.actions.hasError(new Error("We cannot fetch your branches at the moment! Please check back later.")));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteBranch(remove) {
    return async (dispatch) => {
        dispatch(slice.actions.removeDeleteError());
        try {
            const response = await axios.post(API_PATH.branches, { remove });
            if (response.data.status === "success") {
                dispatch(slice.actions.deletedSuccess(remove));
            } else if (response.data.status === "permission_denied") {
                dispatch(slice.actions.hasDeleteError(new Error("You do not have permission to perform this action!")));
            } else if (response.data.status === "cannot_delete") {
                dispatch(slice.actions.hasDeleteError(new Error("You cannot delete the primary branch!")));
            } else {
                dispatch(slice.actions.hasDeleteError(new Error("An error has occured! Please try again later.")));
            }
        } catch (error) {
            dispatch(slice.actions.hasDeleteError(error));
        }
    };
}
